import { mockSuccess } from './shared';
import type { MockRouteEntry } from '../mock-api.types';

const MOCK_MODULES = [
    'support', 'dms', 'store', 'mailing', 'campaign', 'wiki',
    'hrm', 'accounting', 'payroll', 'pms', 'billing', 'website', 'marketing', 'wallet', 'ai',
];

const MOCK_ORGANIZATIONS = [
    {
        id: 1,
        code: 'ashcorp',
        name: 'Ashcorp Addams Ltd',
        slug: 'ashcorp',
        role_codes: ['@ADMIN'],
        roles: { super: true, admin: true, editor: true, viewer: true, secretary: true, accountant: true },
        branches: [
            {
                id: 1,
                code: 'main',
                name: 'Main',
                slug: 'main',
                role_codes: ['@ADMIN'],
                roles: { super: true, admin: true, editor: true, viewer: true, secretary: true, accountant: true },
                modules: MOCK_MODULES,
            },
        ],
    },
];

const MOCK_USER = {
    id: 1,
    email: 'ui-demo@ashcorp.xyz',
    username: 'ui-demo',
    lastname: 'Demo',
    othernames: 'UI',
    status: 'ACTIVE',
    superadmin: true,
};

function mockSessionPayload() {
    return {
        token: 'mock-ui-only-session-token',
        expires_in: 86400,
        expires_at: new Date(Date.now() + 86400000).toISOString(),
        superadmin: true,
        app_id: 1,
        user: MOCK_USER,
        organizations: MOCK_ORGANIZATIONS,
        app: { id: 4, code: 'outbox-test', name: 'Outbox' },
        roles: { super: true, admin: true, editor: true, viewer: true, secretary: true, accountant: true },
        active_modules: MOCK_MODULES,
    };
}

function mockAccessPayload() {
    return {
        user: MOCK_USER,
        superadmin: true,
        app_id: 1,
        active_modules: MOCK_MODULES,
        app_lifecycle: null,
        organizations: MOCK_ORGANIZATIONS,
    };
}

export const AUTH_MOCK_HANDLERS: MockRouteEntry[] = [
    {
        method: 'POST',
        pattern: /\/api\/authentication\/sign-in(\/verify-otp)?$/i,
        handler: () => mockSuccess(mockSessionPayload(), 'Signed in (mock)'),
    },
    {
        method: 'POST',
        pattern: /\/api\/authentication\/refresh-token/i,
        handler: () => mockSuccess(mockSessionPayload(), 'Session refreshed (mock)'),
    },
    {
        method: 'GET',
        pattern: /\/api\/authentication\/access/i,
        handler: () => mockSuccess(mockAccessPayload(), 'Access loaded (mock)'),
    },
    {
        method: 'POST',
        pattern: /\/api\/authentication\/sign-out/i,
        handler: () => mockSuccess({ ok: true }, 'Signed out (mock)'),
    },
];
